export enum VIEW_MODE { ADD = 0, EDIT = 1, VIEW = 2 };